import React from "react";

const MealAdditionItems = ({ additionGroups }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {additionGroups.map((item, index) => (
        <div key={index}>
          {/* Title */}
          <h2 className="text-xl font-semibold text-purple-900">{item.name}</h2>

          {/* Price Info */}
          <p className="flex justify-between pr-4">
            <div className="text-sm text-gray-600 mb-2">
              {item.numberOfFreeItems > 0 ?(
                <>
                  Select any {item.numberOfFreeItems || "0"} {" "}
                  <span className="text-gray-400">[Complimentary]</span>
                </>
              ):(
                <div>Select any item</div>
              )}
            </div>
            <div className="ml-2 text-red-500 font-semibold">
              {Number(item.pricePerAddition).toFixed(2)} TK/Item
            </div>
          </p>

          {/* Items */}
          <div className="space-y-2">
            {item.additionItems.map((item, itemIdx) => (
              <div
                key={itemIdx}
                className="w-full px-4 py-2 rounded bg-gray-100 text-gray-800"
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MealAdditionItems;
